import { logger } from '@web_opxp/features';
import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { HistoryService } from 'web_core_library';
import { isLogout, urlManager } from './services/historyService';

export default function LogoutWrapper() {
  const location = useLocation();
  const redirectLogout = useMemo(() => {
    return isLogout(location.search);
  }, [location.search]);
  const lang = urlManager.getSearchParam('lang');
  const logoutUrl = redirectLogout ? `/opxp/logout/${redirectLogout}` : null;
  if (!logoutUrl) {
    return null;
  }
  const currentPath = location.pathname;
  if (currentPath === logoutUrl) {
    logger(['Already on logout URL, no redirection needed']);
    return null;
  }
  const searchSuffix = lang ? `?lang=${lang}` : undefined;
  logger(['Redirecting to logout URL:', logoutUrl, 'with search suffix:', searchSuffix]);
  HistoryService.redirectInternal(logoutUrl, null, searchSuffix);
  return null;
}
